import { Toast } from "@51job/vant";
import axios from "axios";
import qs from "qs";
import HmacSHA256 from "crypto-js/hmac-sha256";
import store from "@/store";
import router from "@/router";
import isEmpty from "lodash/isEmpty";
import cry from "@/utils/wxcry";
import { cupid_sign_key, young_sign_key } from "@/utils/constant";
// import { getUserToken } from "@/services/user";
import base from "@/utils/common";

//当前需要loading的请求数
let needLoadingRequestCount = 0;
let loadingToast = null;

function showLoading(loading) {
  if (needLoadingRequestCount == 0 && !loadingToast) {
    loadingToast = Toast.loading({
      message: "Loading...",
      forbidClick: loading == "noForbidClick" ? false : true,
      duration: 0,
    });
  }
  needLoadingRequestCount++;
}

function hideLoading() {
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0);
  if (needLoadingRequestCount == 0 && loadingToast) {
    loadingToast.clear();
    loadingToast = null;
  }
}

const getInstanceConfig = (domain) => {
  const config = {
    baseURL: domain,
    timeout: 30000,
    withCredentials: true,
  };
  if (
    domain === "https://cupid.51job.com" ||
    domain === "https://vapi.51job.com" ||
    domain === "https://51gpt.51job.com"
  ) {
    config.headers = {
      post: {
        "Content-Type": "application/json",
      },
      get: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    config.withCredentials = false;
  }
  if (
    domain === "https://youngapi.yingjiesheng.com" ||
    domain === "https://bcop-api.51job.com"
  ) {
    config.headers = {
      post: {
        "Content-Type": "application/json; charset=utf-8",
      },
      get: {
        "Content-Type": "application/json; charset=utf-8",
      },
    };
    config.withCredentials = false;
  }
  if (process.env.VUE_APP_MOCK) {
    config.baseURL = `${window.location.origin}/mock`;
  }
  return config;
};
const errorHandler = (error, url) => {
  if (error.config?.loading) {
    hideLoading();
  }
  Toast.clear();
  if (error.response) {
    try {
      const message = error.response?.data
        ? error.response.data.message
        : error.response.message;
      // 对/open/51job-activities/gift/resume-refresh 接口的 500 错误进行单独处理
      if (
        error.response.status === 500 &&
        url === "/open/51job-activities/gift/resume-refresh"
      ) {
        return Promise.reject(error);
      }
      if (error.response.status != 401)
        Toast(message || "网络请求异常，请稍后重试!");
      //登录失效的错误、令牌失效等，要重新登录
      if (error.response.status == 401) {
        if (store.state.commonStore.platform == "yjsApp") {
          if (store.state.commonStore.isGetUserToken == "1") {
            base.clearlocalStorage();
            base.toLogin();
            // router.go(0);
          } else {
            store.commit("setValueLocalStorage", { isGetUserToken: "1" });
            window.location = "yingjiesheng://home/openLoginPage";
          }
        } else {
          base.clearlocalStorage();
          base.toLogin();
          // router.go(0);
        }
      }
    } catch (e) {
      Toast("网络请求异常，请稍后重试!");
    }
  } else {
    console.log(error);
    Toast("网络请求异常，请稍后重试!");
  }

  console.error(error);
  return Promise.resolve();
};

function setCupidInterceptor($axios) {
  let currentUrl = "";

  $axios.interceptors.request.use((config) => {
    currentUrl = config.url;
    const { method, url, data, params, loading } = config;
    if (loading) {
      showLoading(loading);
    }
    const extraParams = {
      version:
        store.state.commonStore.device == "androidApp" ||
        store.state.commonStore.device == "iosApp"
          ? base.getAppVersion()
          : undefined,
      api_key: "51job",
      timestamp: parseInt(new Date().getTime() / 1000),
    };
    config.url = `${url}?${qs.stringify(extraParams)}`;

    let request_string = config.url;
    if (method === "get" && !isEmpty(params)) {
      if (
        config.url.indexOf(
          "/open/noauth/gold-two-silver-three/search-job-list"
        ) > -1 ||
        config.url.indexOf("/open/noauth/search") > -1 ||
        (config.url.indexOf("/open/51job-activities/floor/hot-job") > -1 &&
          config.isSerializer)
      ) {
        request_string = `${config.url}&${qs.stringify(params)}`;
      } else {
        request_string = `${config.url}&${qs.stringify(params)}`
          .replace(/%2C/g, ",")
          .replace(/%20/g, "+");
      }
    } else if ((method === "post" || method === "delete") && !isEmpty(data)) {
      config.data = JSON.stringify(data);
      request_string = `${config.url}${config.data || ""}`;
    } else if (method === "upload") {
      request_string = `${config.url}${config.data || ""}`;
      config.method = "post";
      config.headers["Content-Type"] = "multipart/form-data";
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      config.data = formData;
    }

    config.headers.sign = HmacSHA256(request_string, cupid_sign_key);
    config.headers["uuid"] = base.getuuid();
    config.headers["From-Domain"] = store.getters.fromdomain;
    config.headers["account-id"] = localStorage.getItem("accountId") || "";
    config.headers["user-token"] = localStorage.getItem("token") || "";
    config.headers["X-Auth-Token"] = localStorage.getItem("X-Auth-Token");
    config.headers["partner"] = store.state.commonStore.partner;
    config.headers["property"] = encodeURIComponent(
      JSON.stringify({ ...base.getProperty(), ...(config.property || {}) })
    );

    return config;
  });
  $axios.interceptors.response.use(
    (response) => {
      if (response.config.loading) {
        hideLoading();
      }
      // handle response for interceptor set one
      return response.data;
    },
    (error) => errorHandler(error, currentUrl)
  );
}

function setVapiInterceptor($axios) {
  $axios.interceptors.request.use((config) => {
    const { method, url, data, property, params } = config;
    const platform = store.state.commonStore.platform;
    let extraParams = {};
    if (platform == "51jobWX") {
      extraParams = {
        version: 400,
        clientid: "000005",
      };
    } else {
      extraParams = {
        version: 400,
        clientid: store.state.commonStore.client_id,
      };
    }
    if (url.indexOf("?") > -1) {
      config.url = `${url}&${qs.stringify(extraParams)}`;
    } else {
      config.url = `${url}?${qs.stringify(extraParams)}`;
    }
    let baseps = {
      accountid: localStorage.getItem("accountId") || "",
      usertoken: localStorage.getItem("token") || "",
      client_id: store.state.commonStore.client_id,
      property: JSON.stringify({
        ...base.getProperty(),
        ...(property || {}),
      }),
    };
    const newData = { ...baseps, ...(data || params || {}) };
    let urlArr = [
      "resource.php?query=associateaddress",
      "resource.php?query=dd",
      "resource.php?query=ddhotlandmark",
      "resource.php?query=ddlandmark",
      "resource.php?query=ddlinelandmark",
      "resource.php?query=associa",
      "resource.php?query=file",
    ];
    if (urlArr.includes(url)) {
      newData.sign = cry.generateSignResource(data.path, platform);
      config.url = url + "&" + qs.stringify(newData);
    } else {
      config.data = {
        sign: cry.generateSign(newData, platform),
        data: JSON.stringify(newData),
      };
    }

    if (method == "post") {
      config.headers["UUID"] = base.getuuid();
      config.headers["From-Domain"] =
        platform === "51jobWX"
          ? "51job_weixin_wxapp"
          : store.getters.fromdomain;
      config.headers["Client-Time"] = parseInt(new Date().getTime() / 1000);
    }
    return config;
  });

  $axios.interceptors.response.use(
    (response) => {
      // if (response.config.loading) {
      //   hideLoading();
      // }
      let noToastStatus = response.config.noToastStatus || [];
      noToastStatus = noToastStatus.concat(["1", "-104", "-30"]);
      if (!noToastStatus.includes(response.data.status)) {
        Toast.clear();
        Toast(response.data.message);
        return response.data;
      }
      //登录信息失效，再获取一次登录态，不行去登录页
      if (response.data.status == "10005") {
        // getUserToken();
        return response.data;
      }
      if (response.data.status != 1) {
        var errMsg = "系统忙，请稍候再试";
        if (response.data.status == "32001") {
          errMsg = "绑定失败，该51job账号已与其他微信绑定";
        } else if (
          response.data.resultbody &&
          response.data.resultbody.error_msg
        ) {
          errMsg = response.data.resultbody.error_msg;
        } else if (response.data && response.data.message) {
          errMsg = response.data.message;
        }
        if (
          parseInt(response.data.status) < 10001 ||
          [
            "10402",
            "10401",
            "10404",
            "10043",
            "10044",
            "10700",
            "10701",
            "10702",
            "10703",
            "10704",
            "10001",
            "10705",
          ].includes(response.data.status)
        ) {
          console.log(response.data.status, "response.data.status");
          Toast.clear();
          errMsg && Toast.fail(errMsg);
        }
      }
      return response.data;
    },
    (error) => errorHandler(error)
  );
}

function setOauthInterceptor($axios) {
  $axios.interceptors.request.use((config) => {
    config.url = `${config.url}?fromdomain=${store.getters.fromdomain}`;
    return config;
  });
  $axios.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => errorHandler(error)
  );
}

function setYoungInterceptor($axios) {
  $axios.interceptors.request.use((config) => {
    const { method, data, params, property, version = "1.1.0" } = config;
    config.url = `${
      config.url
    }?version=${version}&api_key=xy&timestamp=${parseInt(
      new Date().getTime() / 1000
    )}`;

    if (store.state.commonStore.partner)
      config.url += "&partner=" + store.state.commonStore.partner;

    let request_string;
    if (method === "get") {
      if (!isEmpty(params)) {
        request_string = `${config.url}&${qs.stringify(params)}`.replace(
          /%3A/g,
          ":"
        );
      } else {
        request_string = `${config.url}`;
      }
    } else if ((method === "post" || method === "delete") && !isEmpty(data)) {
      config.data = JSON.stringify(data);
      request_string = `${config.url}${config.data || ""}`;
    } else if (method === "upload") {
      request_string = `${config.url}${config.data || ""}`;
      config.method = "post";
      config.headers["Content-Type"] = "multipart/form-data";
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      config.data = formData;
    }

    config.headers.sign = HmacSHA256(request_string, young_sign_key);
    config.headers["user-token"] = localStorage.getItem("token") || "";
    // config.headers['XY-USER-TOKEN'] = localStorage.getItem('token') || '';
    config.headers["account-id"] = localStorage.getItem("accountId") || "";
    config.headers["From-Domain"] = store.getters.fromdomain;
    config.headers["uuid"] = base.getuuid();
    config.headers["partner"] = store.state.commonStore.partner;
    config.headers["property"] = encodeURIComponent(
      JSON.stringify({ ...base.getProperty(), ...(property || {}) })
    );
    return config;
  });
  // 返回拦截
  $axios.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => errorHandler(error)
  );
}

function setMyInterceptor($axios) {
  $axios.interceptors.request.use((config) => {
    return config;
  });
  $axios.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => errorHandler(error)
  );
}

function setUnionInterceptor($axios) {
  $axios.interceptors.request.use((config) => {
    if (store.getters.fromdomain === "yjs_h5") {
      config.url = `${config.url}?type=json&Display=h5`;
    } else {
      config.url = `${config.url}?type=json`;
    }
    return config;
  });
  $axios.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => errorHandler(error)
  );
}

const cupid = axios.create(getInstanceConfig("https://cupid.51job.com"));
const vapi = axios.create(getInstanceConfig("https://vapi.51job.com"));
const oauth = axios.create(getInstanceConfig("https://oauth.51job.com"));
const young = axios.create(
  getInstanceConfig("https://youngapi.yingjiesheng.com")
);
const union = axios.create(getInstanceConfig("https://union.yingjiesheng.com"));
const my = axios.create(getInstanceConfig("https://my.51job.com"));

setCupidInterceptor(cupid);
setVapiInterceptor(vapi);
setOauthInterceptor(oauth);
setYoungInterceptor(young);
setMyInterceptor(my);
setUnionInterceptor(union);

export default {
  cupid,
  vapi,
  oauth,
  young,
  union,
  my,
};
